module.exports = __webpack_public_path__ + "img/ningbo-c72864.png";